import { useAppToast } from "@ui-seeker/app"
import { batch } from "@preact/signals-react"
import { getSubmit, postSubmit } from "@ui-seeker/utils"

import { WEBBACK_V2_API } from "@constants"
import {sku, skuGroup, renderSkuGroup, skuGroupData, isOpenSkuGroupModal} from "@signals"


export default function useSkuGroupModal() {
    const { showToast } = useAppToast()

    const getSkuGroupList = () => getSubmit(`${WEBBACK_V2_API}/master-data/sku-group/options`).then(res => {
		skuGroupData.value = res
	})

    const deleteSkuGroup = skuGroupID => showToast.confirm(`Are you sure you want to delete this SKU Group?`, {
        onSubmit: () => postSubmit(`${WEBBACK_V2_API}/master-data/sku-group/delete`, { skuGroupID: skuGroupID }).then(() => batch(() => {
            skuGroupData.value = skuGroupData.value.filter(row => row.value !== skuGroupID)
            skuGroup.value = skuGroupData.value.filter(row => row.value !== skuGroupID)
            renderSkuGroup.value = true
            isOpenSkuGroupModal.value = false
            showToast.success('Sku Group Deleted')
        })),
        onCancel: () => showToast.info('Delete process cancelled')
    })

    const insertSkuGroup = name => showToast.promise(postSubmit(`${WEBBACK_V2_API}/master-data/sku-group/create`, {
        name: name,
        skuID: sku.value
    }).then(res => batch(() => {
        skuGroupData.value = updateTableData(res)
        renderSkuGroup.value = true
	})), {
        error: 'Error',
        success: `SKU Group successfully created!`,
    })

    const updateTableData = row => {
        return [...skuGroupData.value, row]
    }

    return {
        skuGroupData,
        getSkuGroupList,
        deleteSkuGroup,
        insertSkuGroup
    }
}